import React, { useState } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import {  IconButton, Typography, TextField, Menu, MenuItem } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { DatePicker } from 'antd'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';


export default function Filter() {
  const Theme = { primaryThemeColor: "#1976d2" };
  const [columnVisibility, setColumnVisibility] = useState({
    EmployeeID: true,
    EmployeeName: true,
    Department: true,
    City: true,
    JoiningDate: true,
    DaysInCompany: true,
  });
  const [columnFilters, setColumnFilters] = useState([]);

  // Updated employee data
  const data = [
    { EmployeeID: 'EMP001', EmployeeName: 'John Doe', Department: 'HR', City: 'New York', JoiningDate: '2020-01-15T00:00:00', DaysInCompany: 1461 },
    { EmployeeID: 'EMP002', EmployeeName: 'Jane Smith', Department: 'Finance', City: 'Los Angeles', JoiningDate: '2019-06-20T00:00:00', DaysInCompany: 1883 },
    { EmployeeID: 'EMP003', EmployeeName: 'Jim Brown', Department: 'Engineering', City: 'San Francisco', JoiningDate: '2021-03-12T00:00:00', DaysInCompany: 1042 },
    { EmployeeID: 'EMP004', EmployeeName: 'Jack White', Department: 'Marketing', City: 'Chicago', JoiningDate: '2022-05-08T00:00:00', DaysInCompany: 947 },
    { EmployeeID: 'EMP005', EmployeeName: 'Emily Green', Department: 'Sales', City: 'Miami', JoiningDate: '2018-11-10T00:00:00', DaysInCompany: 2190 },
    { EmployeeID: 'EMP006', EmployeeName: 'Michael Black', Department: 'IT', City: 'Dallas', JoiningDate: '2017-09-05T00:00:00', DaysInCompany: 2579 },
    { EmployeeID: 'EMP007', EmployeeName: 'Sarah Blue', Department: 'Legal', City: 'Boston', JoiningDate: '2023-01-22T00:00:00', DaysInCompany: 340 },
    { EmployeeID: 'EMP008', EmployeeName: 'David Gray', Department: 'Engineering', City: 'Austin', JoiningDate: '2020-07-13T00:00:00', DaysInCompany: 1645 },
    { EmployeeID: 'EMP009', EmployeeName: 'Olivia White', Department: 'HR', City: 'Seattle', JoiningDate: '2022-02-17T00:00:00', DaysInCompany: 987 },
    { EmployeeID: 'EMP010', EmployeeName: 'William Brown', Department: 'Marketing', City: 'Denver', JoiningDate: '2021-10-25T00:00:00', DaysInCompany: 1120 },
  ];
  
  const columns = [
    {
        accessorKey: 'EmployeeID',
        header: 'Employee ID',
    },
    {
        accessorKey: 'EmployeeName',
        header: 'Employee Name',
    },
    {
        accessorKey: 'Department',
        header: 'Department',
    },
    {
        accessorKey: 'City',
        header: 'City',
    },
    {
        accessorKey: 'JoiningDate',
        header: 'Joining Date',
        Cell: ({ cell }) => dayjs(cell.getValue()).format('DD/MM/YYYY'),
        filterFn: (row, columnId, filterValue) => {
            const { startDate, endDate } = filterValue;
            const date = dayjs(row.getValue(columnId));
            if (startDate && endDate) {
                return date.isBetween(startDate, endDate, null,  );
            }
            return true;
        },
        Filter: ({ column, table }) => {
            const handleFilterChange = (startDate, endDate) => {
                table.setColumnFilters([{ id: column.id, value: { startDate: startDate ? dayjs(startDate, 'DD-MM-YYYY') : null, endDate: endDate ? dayjs(endDate, 'DD-MM-YYYY') : null } }]);
            };
            return (
                <ThemeProvider theme={createTheme({ palette: { primary: { main: Theme.primaryThemeColor } } })}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div style={{ display: 'flex', gap: '1rem' }}>
                            <DatePicker
                                value={column.getFilterValue()?.startDate}
                                format="DD-MM-YYYY"
                                onChange={(newValue) => handleFilterChange(newValue?.format('DD-MM-YYYY'), column.getFilterValue()?.endDate)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        value={column.getFilterValue()?.startDate ? dayjs(column.getFilterValue()?.startDate).format('DD-MM-YYYY') : ''}
                                    />
                                )}
                            />
                            <DatePicker
                                value={column.getFilterValue()?.endDate}
                                format="DD-MM-YYYY"
                                onChange={(newValue) => handleFilterChange(column.getFilterValue()?.startDate, newValue?.format('DD-MM-YYYY'))}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        value={column.getFilterValue()?.endDate ? dayjs(column.getFilterValue()?.endDate).format('DD-MM/YYYY') : ''}
                                    />
                                )}
                            />
                        </div>
                    </LocalizationProvider>
                </ThemeProvider>
            );
        },
    },
    {
        accessorKey: 'DaysInCompany',
        header: 'Days in Company',
    },
];
const table = useMaterialReactTable({
  columns,
  data,
  state: { columnVisibility, columnFilters },
  onColumnVisibilityChange: setColumnVisibility,
  onColumnFiltersChange: setColumnFilters,
});

return (
  <div>
    <div className="d-flex justify-content-between align-items-center" style={{ padding: '16px' }}>
      <div className="d-flex align-items-center">
        <IconButton onClick={() => window.history.back()}>
          <ArrowBackIosIcon sx={{ fontSize: "20px" }} />
        </IconButton>
        <Typography variant="h6">Employees</Typography>
      </div>
    </div>

    <MaterialReactTable
      columns={columns}
      data={data}
      enableColumnOrdering
      enablePagination
      enableSorting
      enableColumnFilters
      renderTopToolbarCustomActions={() => (
        <div>
          <Menu anchorEl={null} open={false} onClose={() => {}}>
            <MenuItem onClick={() => console.log("Exporting data")}>Download</MenuItem>
          </Menu>
        </div>
      )}
    />
  </div>
);
}